import React from 'react';
import { profile } from '../data/profile';
export function SiteFooter() {
  return <footer className="bg-ink" data-id="element-86" data-mp="3r8j797765kre">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-8 text-sm text-slate-light sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-87" data-mp="3r9kgr78jdz70">
        <p data-id="element-88" data-mp="3hig1s7iv2ec6">© {new Date().getFullYear()} {profile.fullName}</p>
        <p data-id="element-89" data-mp="3hhwt7hf3p2at">{profile.location}</p>
      </div>
    </footer>;
}